import React from 'react';
import PropTypes from 'prop-types';
import TeammoLogo from './teammo-logo.svg';
import TeammoLogoWhite from './teammo-logo-white.svg';


interface IHeaderCenterProps {
  logoLeft?: any;
}

export default class HeaderCenter extends React.Component<
  IHeaderCenterProps,
  {}
> {
  static defaultProps: IHeaderCenterProps = {
    logoLeft: undefined
  };

  render(): React.ReactNode {
    if (this.props.logoLeft) {
      return (
        <div className="row justify-content-center header-center logo-left">
          <div className="col-12 logo-container">
            <img
              className="logo d-none d-sm-inline-block"
              alt="Teammo"
              src={TeammoLogo}
            />
            <img
              className="logo d-sm-none d-inline-block"
              alt="Teammo"
              src={TeammoLogo}
            />
          </div>
        </div>
      );
    }
    return (
      <div className="row justify-content-center header-center">
        <div className="col-sm-6 logo-container">
          <img
            className="logo d-none d-sm-inline-block"
            alt="Teammo"
            src={TeammoLogo}
          />
          <img
            className="logo d-sm-none d-inline-block"
            alt="Teammo"
            src={TeammoLogo}
          />
        </div>
      </div>
    );
  }
}
